"use client";

import React from "react";
import { MenuItem, Menu, Stack } from "@mui/material";
import { Check, Language } from "@mui/icons-material";
import { i1 } from "@/i18n";
import { setStoredLocale } from "@/utils/localeCookie";
import { useIsVariant } from "@/hooks/useVariant";
import { Typography } from "./wrappers/Typography";
import { Button } from "./wrappers/Button";

interface LocaleSelectorProps {
    style?: React.CSSProperties;
}
export const LocaleSelector = (props: LocaleSelectorProps) => {
    const { style } = props;

    const isCada = useIsVariant("cada");

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (locale: string) => {
        setAnchorEl(null);
        if (locale) {
            i1.changeLanguage(locale);
            setStoredLocale(locale);
        }
    };

    if (!isCada) {
        return null;
    }

    return (
        <>
            <Stack direction="row" alignItems="center" gap={1}>
                <Button startIcon={<Language />} variant="text" sx={style} onClick={handleClick}>
                    <Typography variant="caption" text={i1.language.toLocaleUpperCase()} />
                </Button>
            </Stack>

            <Menu
                id="lng-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose("")}
                sx={{
                    [`& .MuiPaper-root`]: {
                        width: "200px",
                    },
                }}
                slotProps={{ list: { "aria-labelledby": "basic-button" } }}
            >
                <MenuItem
                    sx={{ justifyContent: "space-between" }}
                    onClick={() => handleClose("en")}
                >
                    English
                    {i1.language === "en" ? <Check /> : null}
                </MenuItem>
                <MenuItem
                    sx={{ justifyContent: "space-between" }}
                    onClick={() => handleClose("fr-CA")}
                >
                    Français (CA)
                    {i1.language === "fr-CA" ? <Check /> : null}
                </MenuItem>
            </Menu>
        </>
    );
};
